import { LOGIN_PATH } from "./oidc-routes";
import { trimTrailingSlash } from "./platform-url-utils";

export function buildPortalLoginCallbackUrl(portalBaseUrl: string, callbackTarget: string) {
  const normalizedPortalBaseUrl = trimTrailingSlash(String(portalBaseUrl || "").trim());
  const normalizedCallbackTarget = String(callbackTarget || "").trim();
  if (!normalizedPortalBaseUrl) {
    return "";
  }
  const portalLoginUrl = new URL(LOGIN_PATH, `${normalizedPortalBaseUrl}/`);
  if (normalizedCallbackTarget) {
    portalLoginUrl.searchParams.set("callback", normalizedCallbackTarget);
  }
  portalLoginUrl.searchParams.set("force", "1");
  return portalLoginUrl.toString();
}
